import { Tooltip } from '@material-ui/core';
import { AxiosError } from 'axios';
import { BlockIcon, RestritoIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import CadastroPautaModal from 'components/Modal/CadastroPautaModal/CadastroPautaModal';
import CopyStaves from 'components/Modal/CopyStaves';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import { AuthContext } from 'context/authContext/AuthContext';
import { RegisterContextActions } from 'context/registerContext/RegisterContextActions';
import {
  AssemblyModalities,
  AssemblyType,
  SituationValues,
  StaveTypeNumber,
  StaveTypeString,
  StepIds,
  StepStatus,
} from 'helpers/enums/Assembleia';
import {
  AssembleiaPautaStatus,
  AssembleiaPautaStatusString,
} from 'helpers/enums/AssembleiaPautaStatus';
import { getProfileByJWTRoles } from 'helpers/utils/AuthUtils';
import { clsx } from 'helpers/utils/HTMLUtils';
import {
  getParsedJWTAssessorAccessToken,
  JWTAssessorJson,
} from 'helpers/utils/JWTUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import useOutsideClick from 'hooks/useOutsideClick';
import { useRegisterContext } from 'hooks/useRegisterContext';
import { getAssembleiasAssessorBffEndpoint } from 'library/Apis';
import {
  AssessorCadastroEventoRoutePath,
  AssessorCadastroReuniaoRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import {
  AddCircleIcon,
  ArrowLeftIcon,
  Button,
  ButtonThemes,
  CheckCircleIcon,
  Col,
  Collapse,
  ConfirmModal,
  CopyIcon,
  DraggableIcon,
  DropdownItem,
  DropdownMenu,
  EditIcon,
  IconButton,
  LeftCheckboxWithLabel,
  ModalSizes,
  OptionsIcon,
  PercentLoaderIcon,
  Row,
  ScreenSize,
  Table,
  TimesCircleIcon,
  Title,
  ToastTypes,
  TrashIcon,
  useDropOpened,
} from 'plataforma-fundacao-componentes';
import {
  ChangeEvent,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ApiService from 'services/ApiService';
import { getAgendaRegister, postStaveOrder } from 'services/assessor';
import {
  AuthUserPerfilId,
  IAuthUserPerfil,
} from 'store/modules/auth/IAuthUserPerfil';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { makeEditable } from '../../Cadastro';
import { ReactComponent as ClipsIcon } from './clips.svg';
import styles from './styles.module.scss';
import './styles.scss';
type RepresentanteType = {
  cargo: string;
  idAssociado: number;
  name: string;
};

type TableType = {
  idEvento: string;
  codigoAgencia: string | null;
  descricao: string | null;
  flgRestrita: boolean;
  flgSecreta: boolean;
  idPauta: number;
  itens: {
    descricao: string;
    flgAbstencao: 0 | 1;
    idItemPauta: number;
    representantesChapa?: {
      nomeAssociado: string;
      idAssociado: number;
      idCargo: number;
      idRepresentanteChapa: number;
      cargo:
        | 'DESCONHECIDO'
        | 'PRESIDENTE'
        | 'VICE_PRESIDENTE'
        | 'CONSELHEIRO'
        | 'CONSELHEIRO_EFETIVO'
        | 'CONSELHEIRO_SUPLENTE';
    }[];
  }[];
  numeroNucleo: string | null;
  ordem: number;
  resultadoLiberado: boolean;
  resultadoLiberadoAssociado: boolean;
  resultadoLiberadoPresencial: boolean;
  status: AssembleiaPautaStatus;
  statusPresencial: AssembleiaPautaStatusString;
  tempoRestante: number;
  tempoVotacao: number;
  tipoPauta: StaveTypeNumber;
  titulo: string;
  hasAnexos: boolean;
};

const stavesPrefix = translation.Assessor.Evento.Cadastro.Etapas.Pauta;

export default function Staves(props: { reu?: boolean }) {
  const [selected, setSelected] = useState<any[]>([]);
  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [editButtonLoader, setEditButtonLoader] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [active, setActive] = useState<boolean | number | null>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [newIndex, setNewIndex] = useState<number | undefined>(undefined);
  const [count, setCount] = useState<number>(0);
  const [saveLoad, setSaveLoad] = useState<boolean>(false);

  const {
    state,
    changeState,
    setStepCompleted,
    setStepId,
    surveyStepSetFilter,
    surveyStepSetFilterOld,
    setStepStatus,
  } = useRegisterContext();

  const wrapperRef = useRef<any>([]);
  const countRef = useRef<number>();
  const linesRef = useRef(state.staves.agendas);

  linesRef.current = state.staves.agendas;
  countRef.current = count;

  const dispatchAction = useDispatch();
  const history = useHistory();
  const match = useRouteMatch<{ id?: string; etapa?: string }>();
  const { user } = useContext(AuthContext);
  const { showToast } = useContext(LayoutContext);
  const [dropOpened, toggleDropOpened] = useDropOpened<number | undefined>(
    undefined
  );

  const parsedToken: JWTAssessorJson | null = getParsedJWTAssessorAccessToken(
    user!.access_token
  );
  const perfil: IAuthUserPerfil | null = parsedToken
    ? getProfileByJWTRoles(parsedToken.roles)
    : null;

  const completedStep =
    state.completed.find(
      (item: { step: StepIds }) => item.step === StepIds.staves
    )?.completed && state.status !== StepStatus.EM_EDICAO;

  const presentialBlocked = useMemo(() => {
    return (
      state.data.campos.modality === AssemblyModalities.OFFLINE &&
      state.status === StepStatus.VISUALIZACAO &&
      state.eventStatus === SituationValues.BLOCKED
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.data.campos.modality]);

  const openCadastroPautaModal = useCallback(
    (id?: number | number[]) => {
      if (!match.params.id) return;

      const modalKey: string = getUniqueKey();

      if (id && [String(id)].length) {
        const item: any =
          state.staves.agendas &&
          state.staves.agendas.filter((e: { idPauta: string }) =>
            [String(id)][0]!?.includes(e.idPauta)
          );

        const itensEditarPauta = item[0].itens.map(
          (item: {
            descricao: string;
            flgAbstencao: boolean;
            representantes?: RepresentanteType[];
          }) => ({
            id: getUniqueKey(),
            descricao: item.descricao,
            flgAbstencao: item.flgAbstencao,
            representantes: item.representantes!?.map((x: any) => {
              return {
                idAssociado: x.associateId,
                name: x.associateName,
                roleName: x.roleName,
              };
            }),
          })
        );

        dispatchAction(
          openModal(CadastroPautaModal, {
            modalKey: modalKey,
            idEvento: match.params.id,
            status: 0,
            preventMaskExit: true,
            mobileOn: ScreenSize.xs,
            registering: true,
            idPauta: [String(id)][0],
            currentPage: currentPage,
            cooperativa: state.data.campos.cooperative,
            titulo: item[0].titulo,
            tipoPauta: item[0].tipoPauta,
            descricao: item[0].descricao,
            eleicaoRegister: item[0].electionCommissions,
            itens: itensEditarPauta,
            numeroNucleo: item[0].numeroNucleo,
            codigoAgencia: item[0].codigoAgencia,
            flgRestrita: item[0].flgRestrita,
            flgSecreta: item[0].flgSecreta,
            onClose: () => dispatchAction(closeModal(modalKey)),
            onSend: () => {
              setLoadingTable(true);
              getAgendaRegister(Number(match.params.id))
                .then(({ data }) => {
                  setLoadingTable(false);
                  changeState(RegisterContextActions.STAVES_TABLE_DATA, data);
                  changeState(
                    RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
                    data
                  );
                })
                .catch(() => setLoadingTable(false));
              setSelected([]);
              dispatchAction(closeModal(modalKey));
            },
          })
        );
      } else {
        dispatchAction(
          openModal(CadastroPautaModal, {
            modalKey: modalKey,
            idEvento: match.params.id,
            status: 0,
            preventMaskExit: true,
            mobileOn: ScreenSize.xs,
            registering: true,
            cooperativa: state.data.campos.cooperative,
            onClose: () => dispatchAction(closeModal(modalKey)),
            onSend: () => {
              setLoadingTable(true);
              getAgendaRegister(Number(match.params.id))
                .then(({ data }) => {
                  setLoadingTable(false);
                  changeState(RegisterContextActions.STAVES_TABLE_DATA, data);
                  changeState(
                    RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
                    data
                  );
                })
                .catch(() => setLoadingTable(false));
            },
          })
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      state.data.campos.cooperative,
      dispatchAction,
      match.params.id,
      state.staves.agendas,
    ]
  );

  const openStaveCopyModal = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatchAction(
      openModal(CopyStaves, {
        modalKey: modalKey,
        preventMaskExit: true,
        mobileOn: ScreenSize.xs,
        cooperative: state.data.campos.cooperative,
        eventId: Number(match.params.id),
        onSend: () => {
          setLoadingTable(true);
          getAgendaRegister(Number(match.params.id))
            .then(({ data }) => {
              setLoadingTable(false);
              changeState(RegisterContextActions.STAVES_TABLE_DATA, data);
              changeState(
                RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
                data
              );
            })
            .catch(() => setLoadingTable(false));
          setSelected([]);
          dispatchAction(closeModal(modalKey));
        },
      })
    );
  }, [
    changeState,
    dispatchAction,
    match.params.id,
    state.data.campos.cooperative,
  ]);

  const deleteModal = useCallback(
    (id: number[]) => {
      const mk = getUniqueKey();

      dispatchAction(
        openModal(ConfirmModal, {
          modalKey: mk,
          title: stavesPrefix.Modal.Deletar.Title,
          size: ModalSizes.Large,
          mobileOn: ScreenSize.xs,
          children: stavesPrefix.Modal.Deletar.Mensagem.one,
          onClose: () => {
            dispatchAction(closeModal(mk));
          },
          onCancel: () => {
            dispatchAction(closeModal(mk));
          },
          onConfirm: () => {
            return new Promise<void>(
              (
                resolve: () => void,
                reject: (evt: AxiosError<Error>) => void
              ) => {
                const deleteStaves = {
                  eventId: Number(match.params.id),
                  agendaIds: id,
                };

                ApiService.delete(
                  `${getAssembleiasAssessorBffEndpoint()}agenda/delete-many/true`,
                  { data: deleteStaves }
                )
                  .then(() => {
                    setLoadingTable(true);
                    getAgendaRegister(Number(match.params.id))
                      .then(({ data }) => {
                        setLoadingTable(false);

                        if (state.staves.agendas.length === selected.length) {
                          setCurrentPage(1);
                        }

                        dispatchAction(closeModal(mk));
                        setSelected([]);

                        changeState(
                          RegisterContextActions.STAVES_TABLE_DATA,
                          data
                        );
                        changeState(
                          RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
                          data
                        );
                        resolve();
                      })
                      .catch(() => setLoadingTable(false));
                  })
                  .catch((error) => {
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label:
                        translation.Toasts.Errors.Keys[
                          `${
                            (error as AxiosError<Error>).response?.data
                              .message ||
                            (error as AxiosError<Error>).response?.data ||
                            (error as AxiosError<Error>).message
                          }` as keyof typeof translation.Toasts.Errors.Keys
                        ] ?? translation.Toasts.Errors.defaultAlternative,
                    });
                    reject(error);
                  });
              }
            );
          },
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  const deleteUpperHeaderButton = useCallback(
    (id: number[]) => {
      return {
        icon: <TrashIcon />,
        label: stavesPrefix.Table.UpperHeader.Deletar,
        disabled: completedStep || !id || !id.length,
        onClick: () => deleteModal(id),
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selected]
  );

  const agendaType = (type: StaveTypeNumber) => {
    switch (type) {
      case 0:
        return StaveTypeString.PADRAO;
      case 1:
        return StaveTypeString.CONSELHO;
      case 2:
        return StaveTypeString.COORDENADOR;
      default:
        return '';
    }
  };

  useEffect(() => {
    setStepId(StepIds.staves);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !match.params.id ||
      match.params.id === 'undefined' ||
      match.params.id === undefined
    ) {
      setTimeout(() => {
        if (props.reu) {
          history.push(`${AssessorCadastroReuniaoRoutePath}etapas/dados`);
        } else {
          history.push(`${AssessorCadastroEventoRoutePath}etapas/dados`);
        }
      }, 200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match]);

  // REORDENAMENTO

  const handlSortable = useCallback(
    (items: any[], oldPosition: number, newPosition: number) => {
      const newOrder = [...items];
      const [removed] = newOrder.splice(oldPosition, 1);
      newOrder.splice(newPosition, 0, removed);
      setCount((c) => c + 1);
      changeState(RegisterContextActions.STAVES_TABLE_DATA, newOrder);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleSubmit = useCallback(() => {
    setSaveLoad(true);

    if (
      JSON.stringify(state.staves.agendas) ===
      JSON.stringify(state.staves.agendasOld)
    ) {
      if (state.data.campos.type === AssemblyType.AGN) {
        history.push(
          `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
        );
        setStepCompleted(
          state.completed.map((item: { step: StepIds; completed: boolean }) =>
            item.step === StepIds.staves ? { ...item, completed: true } : item
          )
        );
      } else {
        if (props.reu) {
          history.push(
            `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/anexo`
          );
        } else {
          history.push(
            `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/anexo`
          );
        }

        setStepCompleted(
          state.completed.map((item: { step: StepIds; completed: boolean }) =>
            item.step === StepIds.staves ? { ...item, completed: true } : item
          )
        );
      }
    } else {
      return postStaveOrder({
        eventId: Number(match.params.id),
        agendaIds: state.staves.agendas.map((item: any) => {
          return item.idPauta;
        }),
      })
        .then(() => {
          changeState(
            RegisterContextActions.STAVES_INITIAL_TABLE_DATA,
            state.staves.agendas
          );
          setStepCompleted(
            state.completed.map((item: { step: StepIds; completed: boolean }) =>
              item.step === StepIds.staves ? { ...item, completed: true } : item
            )
          );
          surveyStepSetFilter({ enabled: false });
          surveyStepSetFilterOld(false);
          if (state.showAlert) {
            history.push(state.toPage);
          } else {
            if (state.data.campos.type === AssemblyType.AGN) {
              history.push(
                `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
              );
            } else {
              if (props.reu) {
                history.push(
                  `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/anexo`
                );
              } else {
                history.push(
                  `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/anexo`
                );
              }
            }
          }
          setSaveLoad(false);
        })
        .catch((error) => {
          setSaveLoad(false);
          showToast({
            pauseOnFocusLoss: true,
            theme: ToastTypes.Error,
            showStatusBar: true,
            timeout: 4000,
            label:
              translation.Toasts.Errors.Keys[
                `${
                  (error as AxiosError<Error>).response?.data.message ||
                  (error as AxiosError<Error>).response?.data ||
                  (error as AxiosError<Error>).message
                }` as keyof typeof translation.Toasts.Errors.Keys
              ] ?? translation.Toasts.Errors.defaultAlternative,
          });
        });
    }
  }, [
    state.staves.agendas,
    state.staves.agendasOld,
    state.completed,
    state.showAlert,
    state.toPage,
    state.data.campos.type,
    props.reu,
    history,
    match.params.id,
    changeState,
    setStepCompleted,
    surveyStepSetFilter,
    surveyStepSetFilterOld,
    showToast,
  ]);

  const handleClickOutside = (e: boolean) => {
    if (!e) {
      setActive(false);
      setNewIndex(undefined);
    }
  };

  useOutsideClick(wrapperRef, handleClickOutside);

  const changed = useMemo(() => {
    return (
      JSON.stringify(state.staves.agendas) !==
      JSON.stringify(state.staves.agendasOld)
    );
  }, [state.staves]);

  useEffect(() => {
    if (
      state.showAlert &&
      (state.status === StepStatus.EM_EDICAO ||
        state.eventStatus === SituationValues.EDITABLE)
    ) {
      const mk = getUniqueKey();

      dispatchAction(
        openModal(ConfirmModal, {
          modalKey: mk,
          size: ModalSizes.Large,
          title: 'Confirmação',
          mobileOn: ScreenSize.xs,
          children:
            'Há modificações que ainda não foram salvas. Você deseja salvar essas alterações antes de alterar a etapa atual?',
          onClose: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            dispatchAction(closeModal(mk));
          },
          onCancel: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            changeState(
              RegisterContextActions.STAVES_TABLE_DATA,
              state.staves.agendasOld
            );
            history.push(state.toPage);
            dispatchAction(closeModal(mk));
          },
          onConfirm: () => {
            changeState(RegisterContextActions.SET_SHOW_ALERT, false);
            dispatchAction(closeModal(mk));
            handleSubmit();
          },
          language: {
            confirm: 'Salvar',
            cancel: 'Não salvar',
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.showAlert]);

  return match.params.id &&
    match.params.id !== 'undefined' &&
    match.params.id !== undefined ? (
    <Row className={styles.root}>
      <Row className={styles.title_content}>
        <Col cols={[12, 12, 6, 6, 6]}>
          <Row>
            <Title>{stavesPrefix.Titulo}</Title>
            {state.data.campos.flgEventTest ? (
              <span
                style={{
                  color: '#e60000',
                  fontSize: '12px',
                  marginTop: '12px',
                }}
              >
                {translation.Assessor.Evento.Cadastro.Etapas.Dados.EventoTeste}
              </span>
            ) : (
              <Fragment />
            )}
          </Row>
        </Col>

        {[SituationValues.AVAILABLE, SituationValues.IN_PREPARATION].includes(
          state.eventStatus!
        ) &&
        ((state.status !== StepStatus.EM_EDICAO &&
          [AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!) &&
          props.reu) ||
          ![AuthUserPerfilId.PertencerConsulta].includes(perfil!?.id!)) ? (
          <Col cols={[12, 12, 6, 6, 6]} end buttonActionsCol>
            <Button
              theme={ButtonThemes.Primary}
              leftIcon={<EditIcon />}
              onClick={() => {
                setEditButtonLoader(true);
                makeEditable(
                  String(match.params.id),
                  () => {
                    setEditButtonLoader(false);
                    setStepStatus(StepStatus.EM_EDICAO);
                    changeState(
                      RegisterContextActions.SET_EVENT_STATUS,
                      SituationValues.EDITABLE
                    );
                  },
                  (error) => {
                    setEditButtonLoader(false);
                    showToast({
                      pauseOnFocusLoss: true,
                      theme: ToastTypes.Error,
                      showStatusBar: true,
                      timeout: 4000,
                      label:
                        translation.Toasts.Errors.Keys[
                          `${
                            (error as AxiosError<Error>).response?.data
                              .message ||
                            (error as AxiosError<Error>).response?.data ||
                            (error as AxiosError<Error>).message
                          }` as keyof typeof translation.Toasts.Errors.Keys
                        ] ?? translation.Toasts.Errors.defaultAlternative,
                    });
                  }
                );
              }}
              disabled={editButtonLoader}
              loading={editButtonLoader}
            >
              {stavesPrefix.Buttons.Editar}
            </Button>
          </Col>
        ) : undefined}
        <Row>
          <Col className={styles.button_col}>
            <Button
              theme={ButtonThemes.Primary}
              leftIcon={<AddCircleIcon />}
              onClick={() => (!completedStep ? openCadastroPautaModal() : {})}
              disabled={completedStep || presentialBlocked}
            >
              {stavesPrefix.Buttons.AdicionarPauta}
            </Button>
            <Button
              theme={ButtonThemes.Secondary}
              leftIcon={<CopyIcon />}
              onClick={() => openStaveCopyModal()}
              disabled={completedStep || presentialBlocked}
            >
              {stavesPrefix.Buttons.CopiarPauta}
            </Button>
          </Col>
        </Row>
      </Row>

      <Collapse
        opened={Boolean(state.staves.agendas && state.staves.agendas.length)}
        animateOpacity
      >
        <Row style={{ position: 'relative' }}>
          <Col className={styles.table}>
            {loadingTable ? <Loading inline /> : undefined}
            <Table
              className={'table'}
              sortable={
                state.status === StepStatus.EM_EDICAO ||
                state.eventStatus === SituationValues.EDITABLE
              }
              onSort={(evt) => {
                if (
                  state.status === StepStatus.EM_EDICAO ||
                  state.eventStatus === SituationValues.EDITABLE
                ) {
                  if (evt?.newIndex === evt?.oldIndex) {
                    return;
                  } else {
                    handlSortable(
                      linesRef.current,
                      evt!?.oldIndex,
                      evt!?.newIndex
                    );
                  }
                }
              }}
              columns={[
                {
                  key: 'order',
                  value: (
                    <LeftCheckboxWithLabel
                      anchorLabelToCheckbox={!completedStep}
                      label={'Ordem'}
                      value={
                        Boolean(selected!?.length) &&
                        selected!?.length === state.staves.agendas!?.length
                      }
                      disabled={completedStep}
                      onChange={(val) => {
                        if (val) {
                          setSelected(
                            state.staves.agendas!?.map(
                              (a: { idPauta: string }) => a.idPauta
                            )
                          );
                        } else {
                          setSelected([]);
                        }
                      }}
                    />
                  ),
                  props: {
                    style: { width: '140px' },
                    align: 'center',
                  },
                },
                {
                  key: 'checkbox',
                  props: {
                    align: 'left',
                  },
                  value: 'Título',
                },

                {
                  key: 'type',
                  props: {
                    align: 'left',
                  },
                  value: stavesPrefix.Table.Head.Tipo,
                },
                {
                  key: 'confidentiality',
                  props: {
                    align: 'center',
                  },
                  value: stavesPrefix.Table.Head.Confidencialidade,
                },
                {
                  key: 'options',
                  props: {
                    align: 'left',
                  },
                  value: stavesPrefix.Table.Head.Opcoes,
                },
                {
                  key: 'agency',
                  props: {
                    align: 'center',
                  },
                  value: stavesPrefix.Table.Head.Agencia,
                },
                {
                  key: 'nucleu',
                  props: {
                    align: 'center',
                  },
                  value: stavesPrefix.Table.Head.Nucleo,
                },
                {
                  key: 'actions',
                  value: '',
                  props: { style: { width: '160px' } },
                },
              ]}
              lines={state.staves.agendas!?.map(
                (row: TableType, index: number) => {
                  let optionValues = row.itens.map(
                    (item: { descricao: string }) => item.descricao
                  );
                  let resultOptions = optionValues.join(', ');

                  return {
                    key: `${index}-${count}`,
                    order: (
                      <Fragment>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <LeftCheckboxWithLabel
                            label={''}
                            value={selected!?.indexOf(row.idPauta)! > -1}
                            onChange={(v) => {
                              if (!completedStep) {
                                let sel = [...selected!];
                                if (v) {
                                  sel.push(row.idPauta);
                                } else {
                                  sel = sel.filter((aa) => aa !== row.idPauta);
                                }
                                setSelected(sel);
                              }
                            }}
                            disabled={completedStep}
                            anchorLabelToCheckbox
                          />
                          <div ref={(ref) => (wrapperRef.current[index] = ref)}>
                            <div
                              className={`table-input-container`}
                              onClick={() => {
                                if (
                                  state.status === StepStatus.EM_EDICAO ||
                                  state.eventStatus === SituationValues.EDITABLE
                                ) {
                                  setActive(row.idPauta);
                                }
                              }}
                            >
                              <input
                                data-testid={`reorder-input-${index}`}
                                type={'text'}
                                readOnly={
                                  state.status !== StepStatus.EM_EDICAO ||
                                  state.eventStatus !==
                                    SituationValues.EDITABLE ||
                                  active !== row.idPauta
                                }
                                value={
                                  active === row.idPauta ? newIndex! : index + 1
                                }
                                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                  setNewIndex(Number(e.target.value))
                                }
                                className={
                                  active === row.idPauta &&
                                  (newIndex! > state.staves.agendas.length ||
                                    newIndex! - 1 === index)
                                    ? 'error'
                                    : ''
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              <button
                                className={clsx([
                                  `table-button`,
                                  active === row.idPauta ? 'show' : '',
                                  active === row.idPauta &&
                                  (!newIndex ||
                                    newIndex! === 0 ||
                                    newIndex! - 1 === index ||
                                    newIndex! > state.staves.agendas.length)
                                    ? 'error'
                                    : '',
                                ])}
                                disabled={
                                  active === row.idPauta &&
                                  (!newIndex ||
                                    newIndex! === 0 ||
                                    newIndex! - 1 === index ||
                                    newIndex! > state.staves.agendas.length)
                                }
                                onClick={() => {
                                  if (
                                    state.status === StepStatus.EM_EDICAO ||
                                    state.eventStatus ===
                                      SituationValues.EDITABLE
                                  ) {
                                    if (
                                      active === row.idPauta &&
                                      (!newIndex ||
                                        newIndex! === 0 ||
                                        newIndex! - 1 === index ||
                                        newIndex! > state.staves.agendas.length)
                                    )
                                      return;
                                    setSent(true);
                                    setTimeout(() => {
                                      setActive(null);
                                      setNewIndex(undefined);
                                      handlSortable(
                                        linesRef.current,
                                        index,
                                        newIndex! - 1
                                      );
                                      setSent(false);
                                    }, 1000);
                                  }
                                }}
                                tabIndex={
                                  active === row.idPauta &&
                                  (!newIndex ||
                                    newIndex! === 0 ||
                                    newIndex! > state.staves.agendas.length)
                                    ? -1
                                    : 1
                                }
                              >
                                {active === row.idPauta &&
                                (!newIndex ||
                                  newIndex! === 0 ||
                                  newIndex! - 1 === index ||
                                  newIndex! > state.staves.agendas.length) ? (
                                  <TimesCircleIcon />
                                ) : (
                                  <PercentLoaderIcon
                                    value={'100'}
                                    indefinido={sent}
                                  />
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    ),
                    checkbox: (
                      <Fragment>
                        <Tooltip
                          title={row.titulo}
                          placement={'top'}
                          arrow
                          disableHoverListener={row.titulo.length < 27}
                        >
                          <div>{row.titulo}</div>
                        </Tooltip>
                      </Fragment>
                    ),
                    type: agendaType(row.tipoPauta),
                    confidentiality: (
                      <div className={styles.etiqueta_container}>
                        <div
                          className={clsx([styles.etiquetas, styles.center])}
                        >
                          {row.flgRestrita && (
                            <div className={styles.restrita}>
                              <RestritoIcon />
                              <span>Restrita</span>
                            </div>
                          )}
                          {row.flgSecreta && (
                            <div className={styles.secreta}>
                              <BlockIcon />
                              <span>Secreta</span>
                            </div>
                          )}

                          <span>
                            {!row.flgRestrita && !row.flgSecreta && '-'}
                          </span>
                        </div>
                      </div>
                    ),
                    options: (
                      <Fragment>
                        <Tooltip
                          title={resultOptions}
                          placement={'top'}
                          arrow
                          disableHoverListener={resultOptions.length < 22}
                        >
                          <div>{row.itens ? resultOptions : '-'}</div>
                        </Tooltip>
                      </Fragment>
                    ),
                    agency: row.codigoAgencia ? row.codigoAgencia : '-',
                    nucleu: row.numeroNucleo ? row.numeroNucleo : '-',
                    actions: (
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            gap: '16px',
                            width: '100%',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <IconButton
                            icon={<ClipsIcon />}
                            disabled={!row.hasAnexos}
                            className={styles.clip_button}
                          />
                          <DropdownMenu
                            opened={String(dropOpened) === String(index)}
                            setOpened={(val) => toggleDropOpened(index, val)}
                            closeOnOutClick
                            content={
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                <DropdownItem
                                  label={'Editar'}
                                  onClick={() =>
                                    openCadastroPautaModal([row.idPauta])
                                  }
                                />
                                <DropdownItem
                                  label={'Deletar'}
                                  onClick={() =>
                                    deleteModal([Number(row.idPauta)])
                                  }
                                />
                              </div>
                            }
                          >
                            <IconButton
                              className={clsx([
                                styles.option_icon,
                                'actionButton',
                              ])}
                              icon={<OptionsIcon />}
                              disabled={completedStep}
                              onClick={() => {
                                toggleDropOpened(index, dropOpened !== index);
                              }}
                            />
                          </DropdownMenu>
                          <IconButton
                            disabled={
                              state.status !== StepStatus.EM_EDICAO ||
                              state.eventStatus !== SituationValues.EDITABLE
                            }
                            className={clsx([
                              state.status === StepStatus.EM_EDICAO ||
                              state.eventStatus === SituationValues.EDITABLE
                                ? 'grab-handle'
                                : '',
                              'actionButton',
                            ])}
                            icon={<DraggableIcon />}
                          />
                        </div>
                      </div>
                    ),
                  };
                }
              )}
              upperHeader={{
                active: Boolean(selected!?.length),
                buttons:
                  selected!?.length > 1
                    ? [deleteUpperHeaderButton(selected)]
                    : [
                        {
                          icon: <EditIcon />,
                          label: stavesPrefix.Table.UpperHeader.Editar,
                          onClick: () => openCadastroPautaModal(selected),
                          disabled:
                            completedStep ||
                            selected!?.length! > 1 ||
                            !selected.length,
                        },
                        deleteUpperHeaderButton(selected),
                      ],
              }}
            />
          </Col>
        </Row>
      </Collapse>

      <Row>
        <Col buttonActionsCol end>
          <Button
            theme={ButtonThemes.Secondary}
            onClick={() => {
              changeState(RegisterContextActions.SET_SHOW_ALERT, changed);
              changeState(
                RegisterContextActions.SET_TO_PAGE,
                [
                  AssemblyModalities.OFFLINE,
                  AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                  AssemblyModalities.HIBRIDO_SIMULTANEO,
                ].includes(state.data.campos.modality!)
                  ? props.reu
                    ? `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/local`
                    : `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/local`
                  : props.reu
                  ? `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/entidade`
                  : `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/entidade`
              );

              if (!changed) {
                if (
                  [
                    AssemblyModalities.OFFLINE,
                    AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL,
                    AssemblyModalities.HIBRIDO_SIMULTANEO,
                  ].includes(state.data.campos.modality!)
                ) {
                  if (props.reu) {
                    history.push(
                      `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/local`
                    );
                  } else {
                    history.push(
                      `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/local`
                    );
                  }
                } else {
                  if (props.reu) {
                    history.push(
                      `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/entidade`
                    );
                  } else {
                    history.push(
                      `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/entidade`
                    );
                  }
                }
              }
            }}
            leftIcon={<ArrowLeftIcon />}
          >
            {stavesPrefix.Buttons.Voltar}
          </Button>
          <Button
            theme={ButtonThemes.Primary}
            onClick={() => {
              if (completedStep || presentialBlocked) {
                if (state.data.campos.type === AssemblyType.AGN) {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
                  );
                } else {
                  if (props.reu) {
                    history.push(
                      `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/anexo`
                    );
                  } else {
                    history.push(
                      `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/anexo`
                    );
                  }
                }
              } else if (state.staves.agendas.length > 0) {
                handleSubmit();
              } else {
                setStepCompleted(
                  state.completed.map((item) =>
                    item.step === StepIds.staves
                      ? { ...item, completed: true }
                      : item
                  )
                );
                if (state.data.campos.type === AssemblyType.AGN) {
                  history.push(
                    `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/pesquisa`
                  );
                  surveyStepSetFilter({ enabled: false });
                  surveyStepSetFilterOld(false);
                } else {
                  if (props.reu) {
                    history.push(
                      `${AssessorCadastroReuniaoRoutePath}${match.params.id}/etapas/anexo`
                    );
                  } else {
                    history.push(
                      `${AssessorCadastroEventoRoutePath}${match.params.id}/etapas/anexo`
                    );
                  }
                }
              }
            }}
            disabled={saveLoad}
            loading={saveLoad}
            leftIcon={<CheckCircleIcon />}
          >
            {completedStep || presentialBlocked
              ? stavesPrefix.Buttons.Prosseguir
              : stavesPrefix.Buttons.Salvar}
          </Button>
        </Col>
      </Row>
    </Row>
  ) : (
    <Fragment />
  );
}
